<ion-header
  class="ion-no-border"
  *ngIf="(platformService?.isTouchExperience$ | async) === false"
>
  <ion-toolbar>
    <ion-buttons slot="end">
      <ion-button data-cy="close-modal-button" (click)="closeModal()">
        <ion-icon slot="icon-only" name="close-outline"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content>
  <section>
    <div>
      <h3 class="short-pay-title" data-cy="short-pay-title">
        <ion-icon
          *ngIf="(platformService?.isTouchExperience$ | async) === true"
          (click)="closeModal()"
          data-cy="short-pay-chevron-back"
          name="chevron-back-outline"
        ></ion-icon>
        {{ 'i18n.payments.shortPayModal.title' | translate }}
      </h3>
      <h4 class="short-pay-subtitle" data-cy="short-pay-subtitle">
        {{ 'i18n.payments.shortPayModal.subtitle' | translate }}
      </h4>
    </div>
    <ion-list lines="full" class="option-list" data-cy="option-list">
      <ion-item
        *ngFor="let option of optionsShortPay; let i = index"
        [attr.data-cy]="'option-' + i"
      >
        <ion-label [attr.data-cy]="option.dataCy + '-label'">{{
          option.description
        }}</ion-label>
        <ion-checkbox
          [attr.data-cy]="option.dataCy + '-checkbox'"
          slot="end"
          mode="ios"
          [(ngModel)]="option.selected"
          (ngModelChange)="deselectedOptions(option)"
        ></ion-checkbox>
      </ion-item>
    </ion-list>
  </section>
</ion-content>

<ion-footer class="ion-footer-modal">
  <ion-toolbar>
    <ion-buttons>
      <ion-button
        data-cy="cancel-modal-button"
        [ngClass]="
          platformService?.platformType !==
          platformService?.platformEnum?.mobile
            ? 'usf-outline-green-dsktp-tblt-modal-button'
            : 'usf-outline-green-mobile-modal-button'
        "
        *ngIf="(platformService?.isTouchExperience$ | async) === false"
        (click)="closeModal()"
      >
        {{ 'i18n.common.cancel' | translate }}
      </ion-button>
      <ion-button
        data-cy="save-modal-button"
        [ngClass]="
          platformService?.platformType !==
          platformService?.platformEnum?.mobile
            ? 'usf-fill-green-dsktp-tblt-modal-button'
            : 'usf-fill-green-mobile-modal-button'
        "
        [disabled]="!isSomeOptionSelected"
        (click)="submitShortPayModal()"
      >
        {{ 'i18n.common.save' | translate }}
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-footer>
